/** Idiomas canónicos propiedades — espejo de backend/src/constants/propiedadIdiomas.js */
export const IDIOMA_FUENTE = "es";

export const IDIOMAS_PROPIEDAD = [
  { code: "es", label: "Español" },
  { code: "ca", label: "Català" },
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "nl", label: "Nederlands" },
  { code: "it", label: "Italiano" },
  { code: "pl", label: "Polski" },
  { code: "ru", label: "Русский" },
  { code: "uk", label: "Українська" },
];

export function labelIdioma(code) {
  return IDIOMAS_PROPIEDAD.find((i) => i.code === code)?.label || code;
}
